import { Component, Input } from '@angular/core';
import { UploadStatus } from '../file-upload/file-upload.constants';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: false,
})
export class ProgressBarComponent {
  @Input() progress = 0;
  @Input() status!: UploadStatus;
  readonly uploadStatus = UploadStatus;

  get normalizedProgress(): number {
    return Math.max(0, Math.min(100, this.progress));
  }
}
